var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShapeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 24,
    viewBox: "0 0 96 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#52C41A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.866 1.50005C48.4811 0.833372 47.5189 0.833374 47.134 1.50005L36.866 19.2852C36.4811 19.9519 36.9622 20.7852 37.732 20.7852H58.268C59.0378 20.7852 59.5189 19.9519 59.134 19.2852L48.866 1.50005Z",
    fill: "#FAAD14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1422 1.17157C89.3921 0.421427 88.3747 0 87.3138 0H80.6862C79.6253 0 78.6079 0.421427 77.8578 1.17157L73.1716 5.85776C72.4214 6.6079 72 7.62532 72 8.68619V15.3138C72 16.3747 72.4214 17.3921 73.1716 18.1422L77.8578 22.8284C78.6079 23.5786 79.6253 24 80.6862 24H87.3138C88.3747 24 89.3921 23.5786 90.1422 22.8284L94.8284 18.1422C95.5786 17.3921 96 16.3747 96 15.3138V8.68618C96 7.62532 95.5786 6.6079 94.8284 5.85776L90.1422 1.17157Z",
    fill: "#FF4D4F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeIcon);
export default __webpack_public_path__ + "static/media/ShapeIcon.df1ada29788dcbbc03871b274b48c2fa.svg";
export { ForwardRef as ReactComponent };